import storageAvailable from 'storage-available';
import {doAjax} from 'surveylabJsAssets/common/_ajax';
import _assessmentHelper from '../common/_assessment-helper';

export default function () {

    // Wait until images are loaded as well, see http://stackoverflow.com/a/545005/94289
    $(window).on("load", function () {
        // Constants
        const MAX_LOGGING_ATTEMPTS = 10;

        // Initialize
        const pageReady = Date.now();
        const modulePageIndex = parseInt(<string>$('#js-module-page-index').val(), 10);
        const pageType = $('#js-page-type').val(); // 'instruction' or 'test'
        const timeLimit = parseInt(<string>$('#js-time-limit').val(), 10);
        const isTestPage = pageType == 'test';
        const isInstructionPage = !isTestPage;
        let timeIsRunning = isTestPage;
        let elapsedTime = 0;
        let storedElapsedTime = 0;
        let pauseStart: number = null;
        let pauseDuration = 0; // Sum of durations where the no-answer warning is displayed
        let loggingWaiting = false; // An ajax log request is underway
        let loggingSuccess = false; // Ajax log request successful
        let loggingAttempts = 0;

        const $submitButton = $('#sl-js-next-button');
        if (!storageAvailable('localStorage')) {
            $submitButton.addClass('disabled').attr('disabled', 'disabled');
            $('#localstorage-warning').removeClass('hidden');
            throw new Error("Trying to use BRTA without local storage enabled.");
        }

        // Reset timing on first (instruction) page of the module.
        if (modulePageIndex == 0) {
            localStorage.removeItem("lastNextClick");
            localStorage.removeItem("storedElapsedTime");
        }
        // Read stored elapsed time
        if (isTestPage && localStorage.getItem("storedElapsedTime") !== null) {
            storedElapsedTime = parseInt(localStorage.getItem("storedElapsedTime"), 10);
            elapsedTime = storedElapsedTime;
        }
        const lastNextClick = localStorage.getItem("lastNextClick") !== null ? parseInt(localStorage.getItem("lastNextClick"), 10) : null;

        let noAnswerConfirmed = false;

        // The form is hidden until the item and its images are fully loaded, which is at $(window).load().
        const $form = $('.sl-js-survey-page-form');
        $form.removeClass('hide');

        // Display no-answer warning, or log timing entry for page (item)
        $submitButton.on('click', function (event) {
            if (loggingSuccess) {
                return; // Form will be submitted
            } else {
                event.preventDefault(); // Don't submit form
            }
            if (loggingWaiting || (isInstructionPage && !_assessmentHelper.isCorrectAnswer())) {
                return;
            }

            timeIsRunning = false;
            if (!noAnswerConfirmed && !hasAnswer() && isTestPage) {
                startPause();
                showNoAnswerModal();
            } else {
                stopPause(false);
                const nextClick = Date.now();

                localStorage.setItem("lastNextClick", nextClick.toString());
                localStorage.setItem("storedElapsedTime", elapsedTime.toString());

                logTimingEntry(nextClick);
            }
        });

        // Handle events for the no-answer modal
        const $noAnswerModal = $('#js-no-answer-modal');
        $('.sl-js-confirm-btn', $noAnswerModal).on('click', function (e) {
            e.preventDefault();
            noAnswerConfirmed = true;
            $submitButton.trigger('click');
        });
        $noAnswerModal.on('hide.bs.modal', function () {
            stopPause(true);
        });

        // Loop for updating and displaying elapsed time and checking time limit
        // see http://stackoverflow.com/a/6685414/94289
        (function updateElapsedTime() {
            if (isTestPage) {
                setTimeout(updateElapsedTime, 100);
                if (timeIsRunning) {
                    elapsedTime = getElapsedTime();
                    displayTime(elapsedTime);
                    if (elapsedTime >= timeLimit) {
                        timeIsRunning = false;
                        $('#timeOverModal').modal();
                    }
                }
            }
        })();

        /**
         * Show no-answer warning modal.
         */
        function showNoAnswerModal() {
            $noAnswerModal.modal({
                backdrop: 'static',
                show: true
            });
            // Hide item completely during warning. Changing specific modal is hard with css (http://stackoverflow.com/a/12000478/94289)
            $noAnswerModal.data('bs.modal').$backdrop.css('opacity', 1);
            $noAnswerModal.data('bs.modal').$backdrop.css('background-color', '#E6ECF0');
        }

        function logTimingEntry(nextClick: number): void {
            loggingWaiting = true;
            loggingAttempts++;

            const $body = $("body");
            $body.addClass("wait");

            const timingEntry = {
                'pageID': $("input[name='hidden-page-id']").val(),
                'userSurveyID': $("input[name='hidden-user-survey-id']").val(),
                'pageReady': pageReady,
                'nextClick': nextClick,
                'loadDuration': lastNextClick ? pageReady - lastNextClick : 0,
                'itemDuration': nextClick - pageReady - pauseDuration,
                'pauseDuration': pauseDuration,
                'elapsedTime': elapsedTime
            };
            const ajaxRequest = {
                url: <string>$('#sl-js-log-timing-entry-url').val(),
                type: "POST",
                dataType: "json",
                timeout: 5000,
                data: timingEntry
            };

            //const jqXHR = $.ajax(ajaxRequest);
            const jqXHR = doAjax(ajaxRequest, MAX_LOGGING_ATTEMPTS);
            jqXHR.done(function () {
                loggingSuccess = true;
                $submitButton.trigger('click');
            });
        }

        /**
         * Check if the timing is paused at the moment.
         */
        function isPause(): boolean {
            return pauseStart !== null;
        }

        /**
         * Start pause
         */
        function startPause(): void {
            if (!isPause()) {
                pauseStart = Date.now();
                timeIsRunning = false;
            }
        }

        /**
         * Stop pause and update pause duration.
         */
        function stopPause(resumeTiming: boolean): void {
            if (isPause()) {
                pauseDuration += Date.now() - pauseStart;
                pauseStart = null;
                if (resumeTiming) {
                    timeIsRunning = true;
                }
            }
        }

        /**
         * Displays the elapsed time.
         *
         * @param {number} elapsedTime In milliseconds
         */
        function displayTime(elapsedTime: number): void {
            $('#js-module-time').text(getDisplayTime(elapsedTime));
        }

        /**
         * Returns the current elapsed time in milliseconds.
         */
        function getElapsedTime(): number {
            return Math.min(storedElapsedTime + (Date.now() - pageReady - pauseDuration), timeLimit);
        }

        /**
         * Returns the time as string displayed to the user (format m:ss).
         */
        function getDisplayTime(elapsedTime: number): string {
            const remainingTime = Math.max(timeLimit - elapsedTime, 0);
            const minutes = Math.floor(remainingTime / 60000);
            const seconds = Math.floor((remainingTime % 60000) / 1000);

            return minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
        }

        /**
         * Check if an answer has been given.
         *
         * @returns {boolean}
         */
        function hasAnswer() {
            return $form.find('.js-sctn-response-list input:checked').val() !== undefined;
        }
    });
}
